// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Site footer */
.otw-footer {
  --of-bg: #f1f5fb;
  --of-text: #0f172a;
  --of-muted: #64748b;
  --of-border: #dbe3ee;
  --of-accent: #2e8b3d;
  background: var(--of-bg);
  border-top: 1px solid var(--of-border);
  color: var(--of-text);
  font-family: inherit;
}
.dark .otw-footer {
  --of-bg: #0b1220;
  --of-text: #e2e8f0;
  --of-muted: #94a3b8;
  --of-border: #1f2a44;
  --of-accent: #4ade80;
}
.otw-footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 48px 24px 32px;
  display: grid;
  grid-template-columns: 1.6fr repeat(3, 1fr);
  gap: 32px;
}
.otw-footer-logo img { height: 52px; display: block; }
.otw-footer-tagline { margin: 14px 0 20px; max-width: 320px; color: var(--of-muted); font-size: 15px; line-height: 1.6; }
.otw-footer-social { display: flex; flex-wrap: wrap; gap: 10px; list-style: none; margin: 0; padding: 0; }
.otw-footer-social a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid var(--of-border);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.otw-footer-social a:hover { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12); }
.otw-footer-social img { width: 22px; height: 22px; }
.otw-footer-col h2 {
  margin: 6px 0 14px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--of-muted);
}
.otw-footer-col ul { list-style: none; margin: 0; padding: 0; }
.otw-footer-col li { margin-bottom: 10px; }
.otw-footer-col a {
  color: var(--of-text);
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s ease;
}
.otw-footer-col a:hover { color: var(--of-accent); }
.otw-footer-bottom {
  border-top: 1px solid var(--of-border);
  padding: 18px 24px;
  text-align: center;
}
.otw-footer-bottom p { margin: 0; color: var(--of-muted); font-size: 14px; }

@media (max-width: 991px) {
  .otw-footer-inner { grid-template-columns: repeat(3, 1fr); }
  .otw-footer-brand { grid-column: 1 / -1; }
}
@media (max-width: 575px) {
  .otw-footer-inner { grid-template-columns: 1fr 1fr; padding: 36px 16px 24px; gap: 24px; }
}
`, "",{"version":3,"sources":["webpack://./src/component/front/header/Footer.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;EACxB,sCAAsC;EACtC,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,2CAA2C;EAC3C,SAAS;AACX;AACA,uBAAuB,YAAY,EAAE,cAAc,EAAE;AACrD,sBAAsB,mBAAmB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACxH,qBAAqB,aAAa,EAAE,eAAe,EAAE,SAAS,EAAE,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;AACzG;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,qDAAqD;AACvD;AACA,6BAA6B,2BAA2B,EAAE,6CAA6C,EAAE;AACzG,yBAAyB,WAAW,EAAE,YAAY,EAAE;AACpD;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,qBAAqB,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE;AAC9D,qBAAqB,mBAAmB,EAAE;AAC1C;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;AACA,0BAA0B,uBAAuB,EAAE;AACnD;EACE,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;AACpB;AACA,uBAAuB,SAAS,EAAE,sBAAsB,EAAE,eAAe,EAAE;;AAE3E;EACE,oBAAoB,qCAAqC,EAAE;EAC3D,oBAAoB,mBAAmB,EAAE;AAC3C;AACA;EACE,oBAAoB,8BAA8B,EAAE,uBAAuB,EAAE,SAAS,EAAE;AAC1F","sourcesContent":["/* Site footer */\n.otw-footer {\n  --of-bg: #f1f5fb;\n  --of-text: #0f172a;\n  --of-muted: #64748b;\n  --of-border: #dbe3ee;\n  --of-accent: #2e8b3d;\n  background: var(--of-bg);\n  border-top: 1px solid var(--of-border);\n  color: var(--of-text);\n  font-family: inherit;\n}\n.dark .otw-footer {\n  --of-bg: #0b1220;\n  --of-text: #e2e8f0;\n  --of-muted: #94a3b8;\n  --of-border: #1f2a44;\n  --of-accent: #4ade80;\n}\n.otw-footer-inner {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 48px 24px 32px;\n  display: grid;\n  grid-template-columns: 1.6fr repeat(3, 1fr);\n  gap: 32px;\n}\n.otw-footer-logo img { height: 52px; display: block; }\n.otw-footer-tagline { margin: 14px 0 20px; max-width: 320px; color: var(--of-muted); font-size: 15px; line-height: 1.6; }\n.otw-footer-social { display: flex; flex-wrap: wrap; gap: 10px; list-style: none; margin: 0; padding: 0; }\n.otw-footer-social a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: #fff;\n  border: 1px solid var(--of-border);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n.otw-footer-social a:hover { transform: translateY(-2px); box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12); }\n.otw-footer-social img { width: 22px; height: 22px; }\n.otw-footer-col h2 {\n  margin: 6px 0 14px;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--of-muted);\n}\n.otw-footer-col ul { list-style: none; margin: 0; padding: 0; }\n.otw-footer-col li { margin-bottom: 10px; }\n.otw-footer-col a {\n  color: var(--of-text);\n  font-size: 15px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n.otw-footer-col a:hover { color: var(--of-accent); }\n.otw-footer-bottom {\n  border-top: 1px solid var(--of-border);\n  padding: 18px 24px;\n  text-align: center;\n}\n.otw-footer-bottom p { margin: 0; color: var(--of-muted); font-size: 14px; }\n\n@media (max-width: 991px) {\n  .otw-footer-inner { grid-template-columns: repeat(3, 1fr); }\n  .otw-footer-brand { grid-column: 1 / -1; }\n}\n@media (max-width: 575px) {\n  .otw-footer-inner { grid-template-columns: 1fr 1fr; padding: 36px 16px 24px; gap: 24px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
